import React from 'react';
import styled from '../index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useQuestionStore } from '@/components/AppreciationDay/Questions/QuestionProvider';
import { EcocreditsIcon, CouponIcon } from '@/components/UI/svg/Ecocredits';
import NextImage from '@/components/NextImage';

// interface ExamHeaderProps {}

const ExamHeader: React.FC<any> = ({}) => {
    const { useLang } = useGlobal();
    const { question, rewardCouponCount, rewardTotalPoints } = useQuestionStore();
    // const dispatch = useQuestionDispatch();
    const { t } = useLang('appreciationday');

    const getClassName = (defAns: string, ans?: string) => {
        if (defAns) {
            return defAns === ans ? 'success number' : 'error number';
        }
        return 'number';
    };

    return (
        <div className={styled.exam_header}>
            <div className="number_list">
                {question.map((item, index) => {
                    return (
                        <span className={`${getClassName(item.defAnswer, item.userAnswer)}`} key={item.questionId}>
                            {index < 9 ? `0${index + 1}` : index + 1}
                        </span>
                    );
                })}
            </div>
            <div className="award">
                <span className="points">
                    {rewardTotalPoints} {t('question.ecoCredits')}
                    <span className="coin 00">
                        <NextImage
                            src={require(`@publicLocal/appreciation-day/pc/coin.png`)}
                            alt={t('question.ecoCredits')}
                            aria-label={t('question.ecoCredits')}
                        />
                    </span>
                </span>
                {/* <span className="coupons">
                    {rewardCouponCount} {t('question.coupons')}
                    <CouponIcon />
                    <span className="percent">%</span>
                </span> */}
            </div>
        </div>
    );
};

export default ExamHeader;
